import React from 'react';
import {useI18nContext} from "../../../contexts/I18nContext";
import RoundedButton from "../../../ui_components/RoundedButton/RoundedButton";
import Modal from "../../../ui_components/Modal/Modal";
import {Observer} from "mobx-react-lite";
import Button from "../../../ui_components/Button/Button";
import ButtonType from "../../../ui_components/Button/ButtonType";
import {useCommonContext} from "../../../contexts/CommonContext";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import TextInput from '../../../ui_components/TextInput/TextInput';
import TextInputType from '../../../ui_components/TextInput/TextInputType';
import Icon from '../../../ui_components/Icon/Icon';
import IconName from '../../../ui_components/Icon/enums/IconName';
import Access from "../../Access/AllowAccess/Access";
import {useUserContext} from "../../../contexts/UserContext";
import NewPackageCustomCategoryWeightRangeSalePriceStore from './NewPackageCustomCategoryWeightRangeSalePriceStore';
import NewPackageCustomCategoryWeightRangeSalePriceButtonProperties from './NewPackageCustomCategoryWeightRangeSalePriceButtonProperties';
import PackageDeliveryTypeSelect from '../../Selects/PackageDeliveryTypeSelect/PackageDeliveryTypeSelect';
import { PackageDeliveryType } from '../../../model/packageDelivery/PackageDeliveryType';
import { useStyles } from './NewPackageCustomCategoryWeightRangeSalePriceButton.style';

const NewPackageCustomCategoryWeightRangeSalePriceButton: React.FC<NewPackageCustomCategoryWeightRangeSalePriceButtonProperties> = ({
                                                                  onClick = () => {
                                                                  },
                                                                  onSave = () => {
                                                                  },
                                                                  showIcon = true,
                                                                  showText = true,
                                                                  disabled,
                                                                  className = '',
                                                                  salePriceId,
                                                                  salePriceCustomCategoryWeightRange,
                                                                  customCategoryId,
                                                                  rounded = false,
                                                                  size = ButtonSize.DEFAULT,
                                                                  type = ButtonType.DEFAULT
                                                              }) => {
    const classes = useStyles(showText);

    const i18n = useI18nContext();
    const commonContext = useCommonContext();
    const store = new NewPackageCustomCategoryWeightRangeSalePriceStore(commonContext, salePriceId, customCategoryId, salePriceCustomCategoryWeightRange);

    const userStore = useUserContext();
    if (!userStore.hasAccess(Access.CREATE_SALE_PRICE.valueOf())) {
        return <></>;
    }

    const handleOnclick = async () => {
        await store.openModal();
        onClick();
    }

    const onCloseModal = () => {
        store.closeModal();
    }

    const onTypeChange = (newType: PackageDeliveryType) => {
        store.salePriceCustomCategoryWeightRange.deliveryType = newType;
    }

    const onFromValueChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const newFromValue = event.target.value;
        store.salePriceCustomCategoryWeightRange.from = +newFromValue;
    }

    const onToValueChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const newToValue =  event.target.value;
        store.salePriceCustomCategoryWeightRange.to = +newToValue;
    }

    const onValueChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const newVal = event.target.value;
        store.salePriceCustomCategoryWeightRange.salePrice = +newVal;
    }

    const onSalePriceValuesSave = async () => {
        const saved = await store.save();
        if (saved) {
            store.closeModal();
            if (onSave) {
                onSave();
            }
        }
    }

    const text = salePriceCustomCategoryWeightRange ? "Editar precio de venta" : "Nuevo precio de venta";
    const btnIcon = salePriceCustomCategoryWeightRange ? <Icon name={IconName.EDIT_ICON}/> : <Icon name={IconName.CREATE_ICON}/>;
    const Btn = () => {
        if (rounded) {
            return <RoundedButton
                onClick={handleOnclick}
                className={className}
                disabled={disabled}
                tooltip={!showText ? text : ""}
                text={showText ? text : ""}
                type={type}
                icon={showIcon ? btnIcon : <></>}
            />
        }
        return <Button
            text={showText ? text : ""}
            className={className}
            tooltip={!showText ? text : ""}
            disabled={disabled}
            size={size}
            onClick={handleOnclick}
            type={type}
            startIcon={showIcon ? btnIcon : <></>}
        />
    }
    return <Observer>
        {() => (
            <>
                <Modal fullScreen={false} loading={store.loading} title={text}
                    onClose={onCloseModal}
                    onPressEnter={onSalePriceValuesSave}
                    open={store.isModalOpen}>
                    <div className={classes.modal_container}>
                        <PackageDeliveryTypeSelect 
                            selected={store.salePriceCustomCategoryWeightRange?.deliveryType}
                            onChange={onTypeChange}
                            className={classes.input}
                            fullWidth
                        />
                        <TextInput
                            type={TextInputType.NUMBER}
                            value={store.salePriceCustomCategoryWeightRange?.from}
                            onChange={onFromValueChange}
                            label={i18n.translate("WEIGHT_RANGES_FROM")}
                            className={classes.input}
                            fullWidth
                        />
                        <TextInput
                            type={TextInputType.NUMBER}
                            value={store.salePriceCustomCategoryWeightRange?.to}
                            onChange={onToValueChange}
                            label={i18n.translate("WEIGHT_RANGES_TO")}
                            className={classes.input}
                            fullWidth
                        />
                        <TextInput
                            type={TextInputType.NUMBER}
                            value={store.salePriceCustomCategoryWeightRange?.salePrice}
                            onChange={onValueChange}
                            label={i18n.translate("WEIGHT_RANGES_PRICE")}
                            className={classes.input}
                            fullWidth
                        />
                        <Button
                            loading={store.loading} className={classes.input} onClick={onSalePriceValuesSave}
                            type={ButtonType.SECONDARY}
                            text={i18n.translate("SAVE")}/>
                    </div>
                </Modal>
                <Btn/>
            </>
        )}
    </Observer>
}

export default NewPackageCustomCategoryWeightRangeSalePriceButton;
